<template>
    <page>
        <module title="云仓提货">
            <c-detail title="提货会员基本信息">
                    <c-detail-item label="授权代码">
					<span v-if="baseInfo.login_name && baseInfo.login_name!=''">
						{{baseInfo.login_name}}
					</span>
                        <span v-else>-</span>
                    </c-detail-item>
                    <c-detail-item label="手机号">
                        {{baseInfo.user_manage_mobilephone}}
                    </c-detail-item>
                    <c-detail-item label="昵称">
					<span v-if="baseInfo.nick_name && baseInfo.nick_name!=''">
						{{baseInfo.nick_name}}
					</span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="会员等级">
					<span v-if="baseInfo.user_level_name && baseInfo.user_level_name!=''">
						{{baseInfo.user_level_name}}
					</span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="用户地址">
                        <span v-if="baseInfo.user_address && baseInfo.user_address!=''">
                            {{baseInfo.user_address}}
                        </span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="注册时间">
                        {{baseInfo.create_date}}
                    </c-detail-item>
                </c-detail>

            <c-form title="收货地址">
                <c-form ref="receivingForm">
                    <c-form-item type="hidden" name="order_number"></c-form-item>
                    <c-form-item type="input" label="收货人" name="receiving_name" required></c-form-item>
                    <c-form-item type="input" label="电话" name="receiving_phone" required></c-form-item>
                    <c-form-item type="region" label="默认发货地"
                                 province-name="receiving_address_province_id"
                                 city-name="receiving_address_city_id"
                                 county-name="receiving_address_county_id"
                                 required></c-form-item>
                    <c-form-item type="input" label="地址详情" name="receiving_address_details" required></c-form-item>
                    <c-form-item type="textarea" v-model="analysis_text"  placeholder="请填入收件人姓名、电话、地址信息，系统将自动识别"></c-form-item>
                    <m-operate>
                        <c-button color="red" @click="analysisAddress()" style="margin-right:20px">地址智能识别</c-button>
                    </m-operate>
                </c-form>
            </c-form>

            <c-form title="提货商品">
                <c-form-item>
                    <m-operate class="flex-center-cross">
                        <c-button color="gray" hollow @click="$refs.productSelector.cloudStockOpen(user_id)">添加提货商品</c-button>
                    </m-operate>

                    <c-table ref="productList" v-model="productList" height="500" :paging="false" border>
                        <c-table-column
                                label="商品信息"
                                name="product_name"
                                width="200"
                        >
                            <template v-slot="{data}">
                                <div class="flex-center">
                                    <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                    <p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
                                </div>
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="商品规格"
                                name="product_sku_spec"
                                width="90"
                        ></c-table-column>

                        <c-table-column
                                label="SKU编码"
                                name="product_sku_code"
                                width="130"
                        ></c-table-column>

                        <c-table-column
                                label="价格"
                                name="product_price"
                                width="100"
                        >
                            <template v-slot="{data}">
                                ￥{{data.product_price}}
                            </template>
                        </c-table-column>

                        <c-table-column
                                label="提货数量"
                                width="100"
                        >
                            <template v-slot="{data}">
                                <c-form-item type="hidden" v-model="data.cloud_stock_count"></c-form-item>
                                <c-input decimal="1" :limit="[1,data.cloud_stock_count]" v-model="data.lade_count" width="80" type="number" style="margin: 0 5px;" word="件"></c-input>
                            </template>
                        </c-table-column>

                        <c-table-column
                                type="button"
                                fixed="right"
                                label="操作"
                        >
                            <template v-slot="row">
                                <c-table-button @click="row.remove()">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-form-item>
            </c-form>
            <template slot="button">
                <c-button size="m" @click="submit(1)">确定提交</c-button>
            </template>
        </module>

        <product-selector ref="productSelector" sku multiple @resolve="productSelectHandle"></product-selector>
        <brand-selector ref="brandSelector" multiple @resolve="selectHandle($event, 'brandList', 'id')"></brand-selector>

    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    import brandSelector from '@/components/service/brand_selector.vue'
    import {mapState} from "vuex";

    export default {
        name: 'b_member_user_stock_lade',

        components: {
            productSelector,brandSelector
        },

        props: {
            user_id: String
        },

        data() {
            return {
                baseInfo: {},
                productList: [],
                analysis_text:''
            }
        },
	    computed: {
		    ...mapState(['systemConfig'])
	    },
        watch: {
            user_id() {
                this.getDetail();
            }
        },

        mounted() {
            this.user_id && this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_user/detail',
                    data: {
                        platform_user_id: this.user_id
                    },
                    loading: true,
                    success: data => {
                        this.baseInfo = data.baseInfo;
                        if (data.receivingInfo){
                            this.$refs.receivingForm.set(data.receivingInfo);
                        }
                    }
                });
            },
            productSelectHandle(list) {
              list = list.filter(item => {
                return !this.productList.find(row => {
                    return (row.product_id == item.product_id && row.product_sku == item.product_sku);
                });
              });
              this.productList = this.productList.concat(list);
                this.productList.forEach(item => {
                    item.lade_count = 1;
              });
            },

            selectHandle(list, ref, key) {
                list = list.filter(item => {
                    return !this[ref].find(row => {
                        return row[key] == item[key];
                    });
                });
                this[ref] = this[ref].concat(list);
            },
            //地址智能识别
            analysisAddress() {
                if (!this.analysis_text || this.analysis_text.length == 0){
                    this.$message({
                        text: '请输入需要识别的内容',
                        icon: 'fail'
                    });
                    return false;
                }
                this.request({
                    url: '/platform_user/address/analysis',
                    data: {
                        text: this.analysis_text
                    },
                    loading: true,
                    timeout: false,
                    success: (data, message) => {
                        this.$refs.receivingForm.set(data);
                        this.$message({
                            text: '智能识别成功',
                            icon: 'success'
                        });
                    }
                });
            },

            submit() {
                if (!this.productList || this.productList.length == 0){
                    this.$message({
                        text: '请选择至少一件提货商品',
                        icon: 'fail'
                    });
                    return false;
                }
                this.productList.forEach(item => {
                    if (!item.lade_count || parseInt(item.lade_count)<=0){
                        this.$message({
                            text: '请输入提货数量',
                            icon: 'fail'
                        });
                        return false;
                    }
                    if (parseInt(item.lade_count) > parseInt(item.cloud_stock_count)){
                        this.$message({
                            text: '提货数量（'+item.lade_count+'）超过当前用户云仓库存（'+item.cloud_stock_count+'）,请修改！',
                            icon: 'fail'
                        });
                        return false;
                    }
                });
                this.$refs.receivingForm.submit({
                    url:'/order/user_stock_lade',
                    rule: {
                        receiving_name: '请填写收货人',
                        receiving_phone: '请填写电话',
                        receiving_address_province_id: '请选择收货地址省份',
                        receiving_address_city_id: '请选择收货地址城市',
                        receiving_address_county_id: '请选择收货地址区县',
                        receiving_address_details: '请填写收货地址详情'
                    },
                    dataFormatter: data => {
                        data.platform_user_id = this.user_id
                        data.sku_list = this.productList ? Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                product_sku: item.product_sku,
                                count: parseInt(item.lade_count)
                            }
                        }):[];
                        data.receiving_address = data.receiving_address_details;
                        return data;
                    },

                    success: (data,obj) => {
                        this.$message({
                            text: '提货订单创建成功'
                        });
                        this.$bus.$emit('order.update');
                        this.redirectTo('/order_list');
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>